module.exports = __webpack_public_path__ + "static/media/sastabuy.05477d07.png";